/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getOptionDecoder,
  getOptionEncoder,
  getStructDecoder,
  getStructEncoder,
  getU128Decoder,
  getU128Encoder,
  getU64Decoder,
  getU64Encoder,
  type Codec,
  type Decoder,
  type Encoder,
  type Option,
  type OptionOrNullable,
} from '@solana/kit';
import {
  getLpRebalanceArgsDecoder,
  getLpRebalanceArgsEncoder,
  type LpRebalanceArgs,
  type LpRebalanceArgsArgs,
} from '.';

export type SettleMigratedFeesArgs = {
  minBaseToQuoteOut: bigint;
  minQuoteToBaseOut: bigint;
  lpRebalance: Option<LpRebalanceArgs>;
  minLpSharesOut: bigint;
};

export type SettleMigratedFeesArgsArgs = {
  minBaseToQuoteOut: number | bigint;
  minQuoteToBaseOut: number | bigint;
  lpRebalance: OptionOrNullable<LpRebalanceArgsArgs>;
  minLpSharesOut: number | bigint;
};

export function getSettleMigratedFeesArgsEncoder(): Encoder<SettleMigratedFeesArgsArgs> {
  return getStructEncoder([
    ['minBaseToQuoteOut', getU64Encoder()],
    ['minQuoteToBaseOut', getU64Encoder()],
    ['lpRebalance', getOptionEncoder(getLpRebalanceArgsEncoder())],
    ['minLpSharesOut', getU128Encoder()],
  ]);
}

export function getSettleMigratedFeesArgsDecoder(): Decoder<SettleMigratedFeesArgs> {
  return getStructDecoder([
    ['minBaseToQuoteOut', getU64Decoder()],
    ['minQuoteToBaseOut', getU64Decoder()],
    ['lpRebalance', getOptionDecoder(getLpRebalanceArgsDecoder())],
    ['minLpSharesOut', getU128Decoder()],
  ]);
}

export function getSettleMigratedFeesArgsCodec(): Codec<
  SettleMigratedFeesArgsArgs,
  SettleMigratedFeesArgs
> {
  return combineCodec(
    getSettleMigratedFeesArgsEncoder(),
    getSettleMigratedFeesArgsDecoder(),
  );
}
